export default function ShopRatingDisplay({ shop }) {
  const rating = shop?.rating;
  if (!rating || rating <= 0) return null;

  return (
    <div className="rating-display">
      <div className="stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`star ${star <= Math.round(rating) ? 'filled' : ''}`}
          >
            ★
          </span>
        ))}
      </div>
    </div>
  );
}
